<template>
  <div>
    <Navbar @display-component="toggleDisplay" />
    <transition name="fade" mode="out-in">
      <component
        v-bind:is="currentComponent"
        @report-id="setReportID"
        :account="account"
        :report-name="reportID"
      ></component>
    </transition>
  </div>
</template>

<script>
import Navbar from "@/components/teams/Navbar.vue";
import SyncCalendar from "@/components/teams/SyncCalendar.vue";
import UserPreferences from "@/components/UserPreferences.vue";
import Documentation from "@/components/Documentation.vue";
import ReportDisplay from "@/components/ReportDisplay.vue";
import { accountMixin } from "@/mixins/account.js";

export default {
  name: "MileLogixFT",
  components: {
    Navbar,
    SyncCalendar,
    UserPreferences,
    Documentation,
    ReportDisplay
  },
  data() {
    return {
      currentComponent: "SyncCalendar",
      reportID: ""
    };
  },
  created: function() {
    this.getAccountDetails();
  },
  updated: function() {
    this.getAccountDetails();
  },
  mixins: [accountMixin],
  methods: {
    toggleDisplay(componentName) {
      this.currentComponent = componentName;
    },
    setReportID(reportID) {
      this.reportID = reportID;
      this.toggleDisplay("ReportDisplay");
    }
  }
};
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
